/**
 * 路由守卫，动态添加路由
 */

import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import {isElectron} from "./utils/common";

const whiteList = ['/login','/start','/testHomework', '/cEditor']; // 白名单
const examDomainWhiteList = ['/competition','/competitionResult'];
NProgress.configure({
	showSpinner: false
})

router.beforeEach((to, from, next) => {
	if(isElectron()) {
		const { ipcRenderer } = window.require("electron");
		if(to.name == "cpp"){
			ipcRenderer.send("openCppWin");
			next(from.path)
			NProgress.done()
		}

		if(to.name == "pythonOnline"){
			ipcRenderer.send("openPyWin");
			next(from.path)
			NProgress.done()
		}
	}


	NProgress.start() // 加载进度条
	document.title = '编程学院'

	const hasToken = store.getters.token;
	if (hasToken) {
		if (to.path === '/login' || to.path === '/start') {
			next({ path: '/simulationGame' })
			NProgress.done()
		} else {
			const hasRoles = store.getters.userInfo.roles;
			// if (!hasRoles || hasRoles.length == 0) {
			if (store.getters.addRouters === null || store.getters.addRouters.length === 0) {
				store.dispatch('user/getFinishEveryTiku'); // 获取每日挑战是否通关
				store.dispatch('user/getUserInfo').then(res => {
					const { data } = res;
					store.dispatch('routes/generateRoutes', {
						'roles': ""
					}).then(() => {
						// 根据roles权限生成可访问的路由表
						let routerList = store.getters.addRouters;
						// router.addRoutes(routerList) // 动态添加可访问权限路由表
						for (var i = 0; i < routerList.length; i++) {
							router.addRoute(routerList[i]);
						}
						next({ ...to, replace: true })
					})
				}).catch(error => {
					console.log(error)
					store.dispatch('user/logout').then(() => {
						Message.error("验证失败，请重新登录")
						return false
					})
				})
			} else {
				next()
				NProgress.done()
			}
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) {
			// 点击退出时,会定位到这里
			next()
		} else {
			next(`/login`)
			NProgress.done()
		}
	}
})

router.afterEach(() => {
	NProgress.done() // 结束Progress
})
